module.exports = __webpack_public_path__ + "static/gptw-badge-2025-6e495ca5a4c1d2799f0aca1205a34e69.png";